import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import PubSub from "pubsub-js";
import { oAuth } from "./BasicAppRouter";
import Home from "../../modules/Home";
import auctions from "../../services/ProductsApiService";

export const AuthHomeHandler = ({ t, subdomain, ...props }) => {
  const [redirectPath, setRedirectPath] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuthAndAuctions = async () => {
      if (!oAuth()) {
        setRedirectPath(`/${subdomain}`);
        setLoading(false);
        return;
      }

      try {
        const auctionlist = await auctions();

        if (auctionlist?.results?.length > 0) {
          const {
            auctionType,
            id: auctionId,
            auctionUserId,
            name: auctionName,
            startDate: auctionDate,
          } = auctionlist.results[auctionlist.results.length - 1];

          setRedirectPath(
            `/preview/products/${auctionId}/${encodeURIComponent(
              auctionName
            )}/${encodeURIComponent(auctionDate)}`
          );
        }
      } catch (err) {
        console.error("Error fetching auctions:", err);
      } finally {
        setLoading(false);
      }
    };

    checkAuthAndAuctions();
  }, [subdomain]);

  if (loading) return null; // or a loading spinner

  if (redirectPath) {
    return <Redirect to={redirectPath} />;
  }

  return <Home t={t} {...props} />;
};
